module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Account":{"widgets.settingsForm.widget":[{"value":"Form","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.formElements.oldPassword.element":[{"value":"[name=password]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.formElements.newPassword.element":[{"value":"[name=newPassword]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.formElements.newPasswordCheck.element":[{"value":"[name=newPasswordCheck]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.submit.target":[{"value":"#settings-form","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107010},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.submit.event":[{"value":"submit","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.hooks.onResponse":[{"value":function(response) {
var answer = response.answer.answer;
if (answer.status) {
$('#message').show().text('Your password was successfully changed.');
return;
};
var code = answer.code;
var name = null;
var parent = this.getParent();
switch (code) {
case 1:
name = 'newPassword';
break;
case 2:
name = 'newPasswordCheck';
break;
case 3:
name = 'password';
break;
}
if (!name) {
console.warn('no name for code -> ', code, 'reason -> ', answer.reason)
}
fox.dom.addClass('error', parent.dom1('[name="' + name + '"]').parentNode);
parent.dom1('[error-alias="' + name + '"]').innerHTML = answer.reason;
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107038},"path":"~.SitePage_Account","_fox_":1}],"widgets.settingsForm.methods.send":[{"value":"user.changePassword","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107039},"path":"~.SitePage_Account","_fox_":1}],"handleDom.focus.target":[{"value":"input[type=\"password\"]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107041},"path":"~.SitePage_Account","_fox_":1}],"handleDom.focus.event":[{"value":"focus","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":"~.SitePage_Account","_fox_":1}],"handleDom.focus.callback":[{"value":function (el) {
fox.dom.removeClass('error', el.parentNode);
this.dom1('[error-alias="' + el.name + '"]').innerHTML = '';
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107047},"path":"~.SitePage_Account","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/account.js
// module id = 1133
// module chunks = 4